export default __webpack_public_path__ + "static/media/gallery_11.0ed680ef.jpg";